import { useParams, Navigate } from 'react-router-dom'
import { useSelector } from 'react-redux'

const OwnerRoute = ({ children }) => {
	const { experienceSlug } = useParams()
	const currentExperience = useSelector(
		(state) => state.experience.experienceDetails
	)
	const userPosition = useSelector((state) => state.experience.userPosition)

	if (!currentExperience || !userPosition) return <p>Loading...</p>

	const isOwner =
		currentExperience.slug === experienceSlug && userPosition.level === 'owner'

	return isOwner ? children : <Navigate to='/' replace />
}

export default OwnerRoute
